import { PathBase } from "@constellation-academy/epic-ui";

export class ReportDetailsPath extends PathBase {
	static readonly pathKey = "details";
}
